import React, {useEffect, useRef} from "react";
import {Wave} from "@foobar404/wave";
import {Stack} from "@mui/material";
import {useVolume} from "../../contexts/VolumeContext";

const AUDIO_URL = "/audio/testMusique.mp3";

export const AudioVisualizer: React.FC = () => {
    const audioRef = useRef<HTMLAudioElement | null>(null);
    const canvasRef = useRef<HTMLCanvasElement | null>(null);
    const waveRef = useRef<Wave | null>(null);
    const hasStartedRef = useRef(false);
    const {volume} = useVolume();

    const canvasWidth = () => Math.min(window.innerWidth * 0.5, 800);
    const canvasHeight = () => Math.min(window.innerHeight * 0.8, 800);

    useEffect(() => {
        const handleUserInteraction = () => {
            if (!hasStartedRef.current && audioRef.current && canvasRef.current) {
                hasStartedRef.current = true;

                audioRef.current.play().catch((err) => {
                    console.error("Erreur de lecture audio :", err);
                });

                const size = Math.min(canvasWidth(), canvasHeight());
                const scale = size / 800;

                waveRef.current = new Wave(audioRef.current, canvasRef.current);

                waveRef.current.addAnimation(
                    new waveRef.current.animations.Turntable({
                        fillColor: {gradient: ["lightblue", "#c191ff",  "#da3d94"]},
                        lineWidth: 1,
                        diameter: Math.round(500 * scale),
                        count: 50,
                        cubeHeight: Math.round(15 * scale),
                        gap: Math.round(3 * scale),
                        frequencyBand: "highs",
                    })
                );

                const circleOptions = [
                    310, 285, 260
                ].map((diameter) =>
                    new waveRef.current!.animations.Circles({
                        diameter: Math.round(diameter * scale),
                        count: 3,
                        frequencyBand: "lows",
                        lineColor: {gradient: ["lightblue", "#c191ff", "#da3d94"]},
                        lineWidth: 1,
                    })
                );

                circleOptions.forEach(anim => waveRef.current!.addAnimation(anim));
            }
        };

        // Attacher le gestionnaire une seule fois
        window.addEventListener("click", handleUserInteraction, {once: true});

        return () => {
            window.removeEventListener("click", handleUserInteraction);
        };
    }, []);

    useEffect(() => {
        if (audioRef.current) {
            audioRef.current.volume = volume;
        }
    }, [volume]);

    return (
        <Stack
            sx={{
                height: '100%',
                width: '100%',
                justifyContent: 'center',
                alignItems: 'center',
                overflow: 'hidden',
            }}
        >
            {/* Audio caché */}
            <audio ref={audioRef} src={AUDIO_URL} />
            <canvas
                ref={canvasRef}
                width={canvasWidth()}
                height={canvasHeight()}
                style={{ maxWidth: '100%', maxHeight: '100%' }}
            />
        </Stack>
    );
};

export default AudioVisualizer;
